import { Button as AntdButton } from "antd";

import { useTrackingAdapter } from "../utilities/trackings/useTrackingAdapter";

import type { AvE2EProps } from "../types";
import type { ButtonProps as AntdButtonProps } from "antd/lib";

export type ButtonProps = AvE2EProps & AntdButtonProps;

export function Button(props: ButtonProps) {
  const { testIdPrefix, ...restProps } = props;
  const trackingAdapter = useTrackingAdapter();

  const testId = `${testIdPrefix}-button`;
  const { children } = props;

  return (
    <AntdButton
      data-testid={testId}
      aria-busy={restProps.loading ? true : undefined}
      {...restProps}
      onClick={(...args) => {
        trackingAdapter.onEvent("button_click", {
          id: testId,
          name: children?.toString() ?? "unknown",
        });
        props?.onClick?.(...args);
      }}
    />
  );
}
